import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { auth, db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const initialName = localStorage.getItem('userName') || '';
  const initialFirstName = localStorage.getItem('userFirstName') || '';
  const initialRole = localStorage.getItem('userRole') || '';
  const [claims, setClaims] = useState({});
  const [currentUser, setCurrentUser] = useState(null);
  const [userName, setUserName] = useState(initialName || '');
  const [userFirstName, setUserFirstName] = useState(initialFirstName || '');
  const [userLastName, setUserLastName] = useState('');
  const [userRole, setUserRole] = useState(initialRole || '');
  const [userEmail, setUserEmail] = useState('');
  const [userLoading, setUserLoading] = useState(true);
  const [userVerified, setUserVerified] = useState(
    localStorage.getItem('userVerified') || false,
  );

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      if (user) {
        if (!currentUser) {
          user
            .getIdTokenResult()
            .then((idTokenResult) => {
              setClaims(idTokenResult.claims);
              let role = 'User';
              if (idTokenResult.claims?.superadmin) {
                role = 'Superadmin';
              } else if (idTokenResult.claims?.admin) {
                role = 'Admin';
              } else if (idTokenResult.claims?.staff) {
                role = 'Staff';
              }
              setUserRole(role);
              localStorage.setItem('userRole', role);
            })
            .catch((error) => {
              console.error('Error fetching custom claims', error);
            });

          const userDoc = doc(db, 'users', user.uid);
          getDoc(userDoc)
            .then((docSnapshot) => {
              if (docSnapshot.exists()) {
                const data = docSnapshot.data();
                const name = data.firstName + ' ' + data.lastName;
                setUserName(name);
                setUserFirstName(data.firstName);
                setUserLastName(data.lastName);
                localStorage.setItem('userName', name);
                localStorage.setItem('userFirstName', data.firstName);
                setUserEmail(data.email);
              } else {
                setUserName('');
                setUserFirstName('');
                setUserLastName('');
              }
            })
            .catch((error) => {
              console.error('Error fetching user document', error);
            })
            .finally(() => {
              setUserLoading(false);
            });
        } else {
          setUserLoading(false);
        }
      } else {
        setClaims({});
        setCurrentUser(null);
        setUserName('');
        setUserRole('');
        setUserLoading(false);
        localStorage.setItem('userName', '');
        localStorage.setItem('userRole', '');
        localStorage.setItem('userFirstName', '');
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        claims,
        currentUser,
        userLoading,
        userName,
        userRole,
        userEmail,
        userFirstName,
        userLastName,
        userVerified,
        setUserVerified,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
